// extracted by mini-css-extract-plugin
export default {"buttonAddScore":"ButtonAdd_buttonAddScore__-7C0A","reversedColors":"ButtonAdd_reversedColors__ba5An"};